import {
  getNameDescriptionTableColumn,
} from '@/utils/common/tableColumn'
// import i18n from '@/locales'
// import { currencyUnitMap } from '@/constants/currency'
import currencyRequest from '@Bill/mixins/currencyRequest'
// import { numerify } from '@/filters'
import { getBrandName } from '@/utils/common/hypervisor'

export default {
  mixins: [currencyRequest],
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        field: 'brand',
        onManager: this.onManager,
        hideField: true,
        edit: false,
        editDesc: false,
        showDesc: false,
        addBackup: true,
        slotCallback: row => {
          const brand = getBrandName(row.brand)
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ brand }</side-page-trigger>
          )
        },
      }),
      // {
      //   field: 'amount',
      //   title: i18n.t('bill.text_141'),
      //   sortable: true,
      //   formatter: ({ row }) => {
      //     let sign = ''
      //     if (currencyUnitMap[this.currency]) {
      //       sign = currencyUnitMap[this.currency].sign || ''
      //     }
      //     return `${sign}${numerify(row.amount, '0,0.00')}`
      //   },
      // },
      // {
      //   field: 'year_amount',
      //   title: i18n.t('bill.text_139'),
      //   // sortable: true,
      //   formatter: ({ row }) => {
      //     let sign = ''
      //     if (currencyUnitMap[this.currency]) {
      //       sign = currencyUnitMap[this.currency].sign || ''
      //     }
      //     return `${sign}${numerify(row.year_amount, '0,0.00')}`
      //   },
      // },
    ]
  },
}
